// extracted by mini-css-extract-plugin
module.exports = {"container":"_180sb_-U6_dH37A-ZMoAXW","captcha":"_1pC8QaReeAc3GQ6CUgvdjp"};